module.exports = __webpack_public_path__ + "img/logout.c0bde924.svg";